import * as yup from 'yup'
import { isaacLinkSchema } from 'shared/utils/issak'
import { AnyObject } from 'yup/lib/types'
import { IIsaacLink } from 'shared/interfaces'

declare module 'yup' {
  interface ArraySchema<T> {
    uniqueISAACLink(): ArraySchema<T>
  }
}

function compare(first: string, second: string): boolean {
  return first.trim().toLowerCase() === second.trim().toLowerCase()
}

function checkUniqueISAACLink(list: ReadonlyArray<IIsaacLink> = [], { parent, createError, path }: AnyObject) {
  const { editRow, globalIsaacUrl } = parent
  const allLinks = [...list, ...(globalIsaacUrl || [])]
  for (let i = 0; i < allLinks.length; i++) {
    if (i !== editRow) {
      if (compare(allLinks[i].title, allLinks[editRow].title)) {
        return createError({
          path: `${path}[${editRow}].title`,
          message: 'Description of ISAAC Link should be unique'
        })
      }
      if (compare(allLinks[i].url, allLinks[editRow].url)) {
        return createError({
          path: `${path}[${editRow}].url`,
          message: 'Url should be unique'
        })
      }
    }
  }
  return true
}

yup.addMethod(yup.array, 'uniqueISAACLink', function() {
  return this.test(checkUniqueISAACLink)
})

export const linkValidation = yup.array(isaacLinkSchema)
  .when('editRow', {
    is: (val?: number) => typeof val !== 'undefined',
    then: schema => schema.uniqueISAACLink()
  })
